"use strict";

const Help = require('./help');

// A Game Controller module which handles real time gamification components for client interactions
// Game Controller
window._Lobby = requestImport => {
  // Set self argument to this
  var self = {};

  self.$content = $('#main-content');
  self.$details = $('#details-area');
  self.$lobbyContainer = $('#lobbyContainer');
  self.$castContainer = null;
  self.plays = [];

	// Set up tutorial and add conditions
	const help = new Help();
	const QR = require('./qrcode');

	help.guided.addSkip('in-act-lobby', function () {
		return window.location.pathname !== '/lobby';
	});

	help.guided.addSkip('no-audio', function () {
		return !document.getElementById('lobby-preview-audio');
	});

	const $disconnectModal = $('.disconnect-modal-overlay');

  self.$templates = {
    entryForm: $.templates('#template-lobby-entry-form'),
    lobbyPlays: $.templates('#template-lobby-plays-new'),
    lobbyEdit: $.templates({ markup: '#template-lobby-edit', allowCode: true })
  };

  self.$items = {
	bioModal: $.templates('#template-modal-bio'),
	filterModal: $.templates('#template-modal-filter'),
	mediaPreviewModal: $.templates('#template-media-preview-modal'),
	actModal: $.templates('#template-act-modal'),
    castMember: $.templates('#template-lobby-castMember'),
    deleteConfirmationModal: $.templates('#template-delete-presentation'),
    licenseModal: $.templates("#template-modal-license"),
    errorBox: $.templates('#template-error-box'),
	presentationItem: $.templates('#template-presentationItem')
  };

  self.isReady = false;
  self.countdown = 0;

  self.presentation = (requestImport.presentation ? requestImport.presentation : { _id: "" });
  let isPrivilegedUser = self.isPrivilegedUser = (requestImport.role.isAdmin || self.presentation.owner == user.id || 
    (self.presentation.organization && requestImport.user.organization && requestImport.user.organizationRole && self.presentation.organization._id == requestImport.user.organization._id && requestImport.user.organizationRole.canDirectPlays));
  self.selectedChars = [];
  self.spectators = [];
  self.Settings = {};
  self.cast = [];
  self.spectatorExists = testID => self.spectators.filter(s => s._id == testID).length > 0;
  self.castExists = testID => self.cast.filter(s => s._id == testID).length > 0;

	let targetCollection = '';

	const scrollToSelector = (selector, speed) => {
		if ($(selector).length === 0) {
			return;
		}
		$('html, body').animate({
			scrollTop: $(selector).offset().top - $('.navbar').height() - 60
		}, speed || 2175);
	}

  self.assembleLyricCollection = (mediaItem) => {
	  if (!mediaItem || !mediaItem.synced || mediaItem.synced.find(s => s.type.name == "Lyric-Extended" && s.lyrics.length > 0) === undefined)
		  return [];

	const originalLyrics = mediaItem.synced.find(s => s.type.name == "Lyric-Extended" && s.lyrics.length > 0).lyrics;
	
	let returnArr = [];
	let lineNumber = 0;
	originalLyrics.forEach(word => {

		if (!returnArr[lineNumber]) {
			returnArr.push({line: '', timing: [], min: 0, max: 0})
		}
		
		const currentLine = returnArr[lineNumber];
		
		currentLine.line += word.words+" "
		currentLine.timing.push(word);
		currentLine.max = word.time;

		if (currentLine.timing.length === 1) {
			currentLine.min = currentLine.timing[0].time;
		}

		if (word.eol) {
			currentLine.line = currentLine.line.trim("");
			lineNumber++;
		}
	});

	return returnArr;
  }

  self.moveAnimate = function (element, newParent, leaveOriginal) {
    //Allow passing in either a jQuery object or selector
    element = $(element);
    newParent = $(newParent);
    let clone = element.clone();

    let oldOffset = element.offset();

    let destObj = (leaveOriginal ? clone : element);
    destObj.appendTo(newParent);
    let newOffset = destObj.offset();

    var temp = element.clone().appendTo('body');
    temp.css({
      'position': 'absolute',
      'left': oldOffset.left,
      'top': oldOffset.top,
      'z-index': 1000
    });
    destObj.css('opacity', 0);
    temp.animate({ 'top': newOffset.top, 'left': newOffset.left }, 'slow', function () {
      destObj.css('opacity', 1);
      temp.remove();
    });
  };
  self.updateJoinIcons = function () {
    $("#roleContainer li.character-select-item").each((k, v) => {
      if ($(v).find('.self-user').length > 0) {
        $(v).find('i.toggleIcon').removeClass('fa-plus-square').addClass('fa-minus-square');
      } else {
        $(v).find('i.toggleIcon').addClass('fa-plus-square').removeClass('fa-minus-square');
      }
    })
  }
  self.displayError = message => {
    let box = self.$items.errorBox.render({ message: message })
    let $box = $(box);
    self.$lobbyContainer.prepend($box);
    $box.fadeIn(555);
    setTimeout(() => $box.fadeOut(555), 10 * 1000);
  };
  self.prepareSortable = function () {
    let dropFunction = function (event) {
      let $targetList = $(event.to);
      let counter = 0;
      let $item = $(event.clone);
      let from = event.from;
      let to = event.to;
      let isFromAnotherRole = ($(from)[0] !== $("ul#castSourceList")[0]);
      let goodForAssignment = true;
      let send = { userId: $item.attr('data-user-id'), characterId: $(to).attr('data-character-id'), presentationId: self.presentation._id };

      $targetList.find('li.list-group-item').each(function (k, v) {
        if ($(v).attr('data-user-id') == $(event.clone).attr('data-user-id')) {
          counter++;
          let $this = $(v);
          let $parent = $($this.parent()[0]);
          $(v).attr('data-character-id', $parent.attr('data-character-id'))
            .attr('data-presentation-id', self.presentation._id);
          // if this item exists more than once, than it's a duplicate and we should remove it.
          if (counter > 1) {
            $(v).remove();
            // dropping a user to an undroppable area effectively deletes them from their old role.
            send.characterId = $(from).attr('data-character-id');
            self.lobby.emit('unassign', send);
            goodForAssignment = false;
            return false;
          } else {

          }
        }
      });

      // send the role assignment query

      if (goodForAssignment && send.userId && send.characterId) {
        self.lobby.emit('assign', send);
      }

      // if they are dragged from another role, we need to unassign them from that role.
      if (isFromAnotherRole && $(to)[0] !== $("ul#castSourceList")[0]) {
        send.characterId = $(from).attr('data-role-id');
        self.lobby.emit('unassign', send);
      }
    };

    let restrictedPull = function (to, from, item) {
      let role = requestImport.role;
      let pullAllowed = (self.isPrivilegedUser || (self.Settings.openCasting == true && $(item).hasClass('self-user')));

      return pullAllowed ? ($(from.el).attr('id') == "castSourceList" ? 'clone' : true) : false;
    }

    let restrictedPut = function (to, from, item) {
      let role = requestImport.role;
      let putAllowed = (self.isPrivilegedUser || (self.Settings.openCasting == true && $(item).hasClass('self-user')));

      return putAllowed;
	}

	// this allows us to unassign users if they are dropped to a non-list element, for example unassigning a user by dragging them away from the role slot without needing to drop them back in the source list.
	let onEnd = (evt) => {
		let putAllowed = (self.isPrivilegedUser || (self.Settings.openCasting == true && $(this).hasClass('self-user')));

		if (!putAllowed)
			return;

		if (evt.to == evt.from) {
			let $origin = $(evt.to);
			let $actor = $(evt.item);
			let send = { userId: $actor.attr('data-user-id'), characterId: $origin.attr('data-character-id'), presentationId: self.presentation._id };

			if (!$origin.is(":hover")) {
				self.lobby.emit('unassign', send);
				$actor.fadeOut(300, () => $actor.remove())
			}
		}
	}
    let sourceListOption = { group: { name: 'roleDrop', put: restrictedPut, revertClone: true, pull: restrictedPull }, onAdd: dropFunction, fallbackTolerance: 5, animation: 250, scroll: true, scrollSpeed: 50, scrollSensitivity: 100, ghostClass: 'ghost', sort: true };
    let roleOption = { group: { name: 'roleDrop', put: restrictedPut, pull: restrictedPull }, onAdd: dropFunction, onEnd: onEnd, animation: 250, fallbackTolerance: 5, scroll: true, ghostClass: 'ghost', scrollSpeed: 50, scrollSensitivity: 100, sort: true };

    Sortable.create(castSourceList, sourceListOption);

    $("ul#roleContainer ul").each(function (k, v) {
      Sortable.create(v, roleOption);
    });

    (function (l) { var i, s = { touchend: function () { } }; for (i in s) l.addEventListener(i, s) })(document);
  };

  window.addEventListener('popstate', e => {
    if (e.state && e.state.presentationId) {
      self.lobby.emit('show', { targetSelf: true, presentationId: e.state.presentationId });
    } else {
      window.location = '/lobby';
    }
  });
  // Update bootstrap navigation
  $('li.active').removeClass('active');
  $('li a[href="/lobby"]').parent().addClass('active')

  $("body").append(self.$items.deleteConfirmationModal.render({ presentation: self.presentation, user: window.user }));
  self.$lobbyContainer.find("#joinbox").html(self.$templates.entryForm.render({ presentation: self.presentation, user: window.user }));

  function detectWebcam(callback) {
	let md = navigator.mediaDevices;
	if (!md || !md.enumerateDevices) return callback(false);
	md.enumerateDevices().then(devices => {
	  callback(devices.some(device => 'videoinput' === device.kind));
	})
  }
  
  detectWebcam(function(hasWebcam) {
	if (!hasWebcam) {
		$('.btn-qr').hide();
	}
  })

  $(".btn-qr").click(() => {
	var $qrVideo = $('video.qrFeed');
	if (!$qrVideo.hasClass("showing")) {
		var scanner = new QR.scanner($qrVideo[0], result => {
			// we have to make sure the data is actually a lobby URL.
			// not exactly elegant, but we want to dissemble the URL, remove the last part of the URL (while saving it) and then re-assembling the remaining to make sure it matches domain we're on.
			let resultSplit = result.split('/');
			let lobbyCode = resultSplit.pop();
			let baseURL = resultSplit.join("/");

			if (baseURL == window.location.origin) {
				$("#codewordInput").val(lobbyCode);
				// close the camera
				$(".btn-qr").click();

				if ($("#nicknameInput").length == 0) {
					// click the button!
					$(".lobby-enter-button").click()
				}
			} else {
				console.log("Invalid QR code, no origin match", result);
			}
		});
		$qrVideo.show();
		$(".close-camera").show();
		$qrVideo.data('scanner', scanner);
		$qrVideo.addClass('showing');
		$qrVideo.css('max-height', 400);
		$qrVideo.css('padding-bottom', 6);
		scanner.start();
	} else {
		$qrVideo.css('max-height', 0).removeClass('showing');
		$(".close-camera").hide();
		$qrVideo.css('padding-bottom', 0)
		$qrVideo.data('scanner').destroy();
		$qrVideo.data('scanner', null);

	}
  });
  
  $('div.joinLobby input').on('keydown', function(event) {
    const $this = $(this);

    if ($this.hasClass('is-invalid'))
      $this.removeClass('is-invalid');
  })
  $('.lobby-enter-button').on('click', event => {
    // if the form exists (anon user signup) then submit it
    let $form = $("form.anonsignup");

    $('div.joinLobby .is-invalid').removeClass('is-invalid');

    const $codeWordField = $("#codewordInput");
    const $nicknameField = $('#nicknameInput');

    const $codewordFeedback = $('#validationCodewordInputFeedback');
    const $nicknameFeedback = $('#validationNicknameInput');


    const codeWordValue =  ($codeWordField.val() || "").trim();
    const nicknameValue = ($nicknameField.val() || "").trim();

    if ($form.length > 0) {

      $form.find('input').each((key, element) => {
        let $field = $(element);
        let value = $field.val() || "";

        $field.val(value.trim());
      });

      if (codeWordValue.length === 0 || nicknameValue.length === 0)  {
        
        if (codeWordValue.length === 0) {
          $codeWordField.addClass('is-invalid');
          $codewordFeedback.text('Please provide a code word.');
        }

        if (nicknameValue.length === 0) {
          $nicknameField.addClass('is-invalid');
          $nicknameFeedback.text('Please provide a Nickname.');
        }

        return;
      }

      $form.submit();
    }
    else {
      if (codeWordValue.length === 0) {
          $codeWordField.addClass('is-invalid');
          $codewordFeedback.text('Please provide a code word.');
          return;
      }
      self.lobby.emit('showbyname', { commonName: $("#codewordInput").val().trim() });

    }
  });

  $('#codewordInput').keypress(event => { if (event.keyCode && event.keyCode == 13) $('.lobby-enter-button').click(); });
  // The socket.io connections rely on user token for security
  self.lobby = io.connect('/lobby', { query: "token=" + (!!user.token && user.token) })
    .on('start', function (data) {

      // Check if the web venue has been selected
      const webVenue = self.presentation.availableVenues.find(venue => venue.unity == 'web-' + self.presentation._id);
      const webVenueSelected = self.presentation.venues.find(venueId => webVenue && venueId == webVenue._id);

      let url = webVenueSelected ? '/player/' : '/present/';
      url += self.presentation._id;
      url += (self.isPrivilegedUser && data.directorUserId && String(data.directorUserId) == user.id) ? '/direct': '';
      
      window.location.href = url;
    })
    .on('countdown', function (time) {
      self.countdown = time;
      $('.lobby-countdown').show().html(time);
      $('.lobby-countdown').css('box-shadow', '#00000 0px 0px '+(parseInt(time)*4+1)+'px 0px');
      console.log("countdown: ", time);
	})
	.on('disconnect', (reason) => setTimeout(() => $disconnectModal.show(), 500))
	.on('reconnect', () => {
		$disconnectModal.hide();
      if (self.presentation._id) {
        self.lobby.emit('show', { targetSelf: true, presentationId: self.presentation._id });
      } else {
        // Lists the current presentations for the user
        self.lobby.emit('list', { targetCollection });
      }

    })
	.on('created-presentation', function(data) {
		$('#emptyPresentationsMsg').fadeOut();
		let newPres = data.newPresentation;
		let isPrivilegedUser = (requestImport.role.isAdmin || newPres.owner == user.id || 
			(newPres.organization && requestImport.user.organization && requestImport.user.organizationRole  && newPres.organization._id == requestImport.user.organization._id 
				&& requestImport.user.organizationRole.canDirectPlays));

		if (!self.presentation._id) {
			newPres.isPrivilegedUser = isPrivilegedUser;
			const $newPresentation = $(self.$items.presentationItem.render(newPres));

			$("#lobby-presentations").prepend($newPresentation);

			// briefly animate it to show it's new.
			$newPresentation.addClass('deletePending');
			setTimeout(() => $newPresentation.removeClass('deletePending'), 2750);

			$newPresentation.find('.deleteBtn').on('mouseover', function (e) {
				let $this = $(this);
				let $presentationBox = $this.parents('.lobby-play-box').find('.lobby-play-title-container');
				
				if ($presentationBox.hasClass('deletePending'))
					return;
	
				$('.deletePending').removeClass('deletePending');
				$presentationBox.addClass('deletePending');
			}).on('mouseout', function (e) {
				let $this = $(this);
				let $parent = $this.parents('.lobby-play-box');
				let $presentationBox = $parent.find('.lobby-play-title-container');
			
				$presentationBox.removeClass('deletePending');
			}).on('click', function (e) {
				let $this = $(this);
				let $presentationBox = $this.parents('.lobby-play-box').find('.lobby-play-title-container');
				let presentationId = $presentationBox.data('presentation-id');
	
				let $modal = $("#deleteConfirmation").clone(true).modal({ keyboard: false, backdrop: 'static', show: true });
				$modal.find(".delete-confirm").click(() => { 
					self.lobby.emit('delete', { presentationId: presentationId, fromList: true })
					$modal.modal('hide');
					setTimeout(() => $modal.remove(), 500);
				});
	
			})


			$newPresentation.find('.presentationItem').on('click', function(e) {
				let $this = $(this);
				self.lobby.emit('show', { targetSelf: true, presentationId: $this.attr('data-presentation-id') });
			})
		}
	})
	.on('unspectate', data => {
		// we have quit the presentation or been removed from it
		window.location = "/lobby";
	})
    .on('event', function (data) {
    //   console.log('lobby event (data)', data);
      // load the user into the returned data for the js templates to use
      data.user = window.user;

      // Show lobby interface to let users select their presentation
      if (data.presentations || data.plays) {
        data.presentations = data.presentations || {};
        data.requestImport = requestImport;
		self.plays = data.plays || [];
		self.hasEntitlement = !!data.hasEntitlement;

        self.$lobbyContainer.find("#playContainer").html(self.$templates.lobbyPlays.render(data));
        $('title').text("ActorsBible - Lobby");
        window.history.pushState({ presentationId: null }, "ActorsBible - Lobby - ", "lobby");
        
		$('#emptyPresentationsMsg').hide();


        $('.lobby-play-box .presentationItem').click(function () {
          var $this = $(this);
          console.log("show ", { presentationId: $this.attr('data-presentation-id') });
          self.lobby.emit('show', { targetSelf: true, presentationId: $this.attr('data-presentation-id') });
        });


        $('.deleteBtn').on('mouseover', function (e) {
			let $this = $(this);
			let $presentationBox = $this.parents('.lobby-play-box').find('.lobby-play-title-container');
			
			if ($presentationBox.hasClass('deletePending'))
				return;

			$('.deletePending').removeClass('deletePending');
			$presentationBox.addClass('deletePending');
		});

		$('.deleteBtn').on('mouseout', function (e) {
			let $this = $(this);
			let $parent = $this.parents('.lobby-play-box');
			let $presentationBox = $parent.find('.lobby-play-title-container');
		
			$presentationBox.removeClass('deletePending');
		});

		$('.deleteBtn').on('click', function (e) {
			let $this = $(this);
			let $presentationBox = $this.parents('.lobby-play-box').find('.lobby-play-title-container');
			let presentationId = $presentationBox.data('presentation-id');

			let $modal = $("#deleteConfirmation").clone(true).modal({ keyboard: false, backdrop: 'static', show: true });
			$modal.find(".delete-confirm").click(() => { 
				self.lobby.emit('delete', { presentationId: presentationId, fromList: true })
				$modal.modal('hide');
				setTimeout(() => $modal.remove(), 500);
			});

		})

		// collection selector:
		const $collectionSelector = $('.collectionSelector');

		if (data.targetCollection) {
			$collectionSelector.find('option[value="' + data.targetCollection._id + '"]').prop('selected', true);
		}

		$collectionSelector.on('change', function (e) {
			targetCollection = $(this).find('option:selected').val();
			self.lobby.emit('list', { targetCollection: targetCollection });
		});
		
        // Sort them by the first number in the title (i.e., Act 45: Some Title)
        let $originalSort = $('#availableActs').children();
     
		$('.playItemContainer').each((k,v) => {
			let titleText = $(v).find('.actHeader .headerLabel').data('act-name');
			let firstNumber = titleText.match(/[0-9]+/);
			$(v).data('sortkey', firstNumber ? parseInt(firstNumber) : -1);
		});
		

		const actNumberSorter = (aObj,bObj) => {
			const a = parseInt($(aObj).data("sortkey"), 10);
			const b = parseInt($(bObj).data("sortkey"), 10);

			if(a > b) {
				return 1;
			} else if(a < b) {
				return -1;
			} else {
				
				return $(aObj).data("actName").localeCompare($(bObj).data('actName'));
			}
		}

		const demoSceneSorter = (x, y) => {
			if (x === y) {
				return 0;
			} else if (x) {
				return -1;
			} else {
				return 1;
			}
		}
		

        $originalSort.sort(function (aObj, bObj) {
			// convert to integers from strings
			const $a = $(aObj);
			const a = parseInt($a.data("sortkey"), 10);
			const aDemo = !!$a.data('isdemoscene');

			const $b = $(bObj);
			const b = parseInt($(bObj).data("sortkey"), 10);
			const bDemo = !!$b.data('isdemoscene');

			return !self.hasEntitlement ? demoSceneSorter(aDemo, bDemo) || actNumberSorter(aObj, bObj) : actNumberSorter(aObj, bObj);
        });

        // put sorted results back on page
		const $availableActs = $('#availableActs');

        $availableActs.html($originalSort);

		$availableActs.data('filtered', {include: [], exclude:[]});

		// before we do anything based off position, we have to remove the Plays with no acts in them

		$('.playItemContainer').each((index,value) => {
			let $playItem = $(value).find('.playItem');
			let playInfo = self.plays.find(x => x._id === $playItem.data('playId'));

			if (playInfo.acts.length === 0) {
				$(value).remove();
				return;
			}
		})
		// set up lazy loading for the Act images
		// and load in data about the act into the object

		$('.playItemContainer').each((index, value) => {
			let $playItem = $(value).find('.playItem');
			let playInfo = self.plays.find(x => x._id === $playItem.data('playId'));

			$playItem.data('play', playInfo);

			if (playInfo.pctComplete == 100) {
				let $pb = $playItem.find('.progress-bar');

				$pb.removeClass($pb.data("normalColor")).addClass($pb.data('completeColor'));
			}
	
			const io = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry =>{	  
					if (entry.isIntersecting) {
					
					let $itemContainer = $(entry.target);
					let targets = [$itemContainer[0], ...$itemContainer.nextUntil().slice(0, 3)];
		
					targets.forEach((container) => {
						let $container = $(container);
						let $elem = $container.find('img.lazyLoad');

						if (!$elem.data('loaded')) {
							$elem.attr('src', $elem.data('src'));
							$elem.data('loaded', true);
						}
					})
						observer.disconnect();
					}
				});
			}, {rootMargin: '15% 0px 15% 0px'});

			io.observe(value);
		});


		// lobby act filtering
		let $filterModal = $(self.$items.filterModal.render({difficulties: data.difficulties}));		
		$('#filter_modal_container').html($filterModal);
		$('.filterBtn').on('click', () => { 
			$filterModal.modal('show');
			$filterModal.data('linkedPlay', null);
		});

		$filterModal.on('hidden.bs.modal', function() {
			if ($filterModal.data('linkedPlay')) {
				$filterModal.data('linkedPlay').click();
			}
		});

		$('.playItem').on('click', function() {
			const $playItem = $(this);
			const isDemoScene = $playItem.parents('.playItemContainer').data('isdemoscene');
			const entitlement = isDemoScene || self.hasEntitlement;

			if (!entitlement) { 
				console.log(requestImport);
				let message = 'This act is only available to those with a paid subscription.';

				if (!requestImport.isAdult) {
					message += ' <br><br>Please contact your parent or legal contact and ask them to subscribe.'
				}

				const renderOptions = 
				{
					message,
					okButton:true, 
					subscribeButton: !!requestImport.isAdult
				}
				let modal = self.$items.licenseModal.render(renderOptions);
				$(modal).modal({keyboard: false, backdrop: 'static'});
				return 0;
			}

			let $modal = $(self.$items.actModal.render($playItem.data('play')));

			$filterModal.data('linkedPlay', $playItem);

			$modal.modal({
				backdrop: true,
				keyboard: true,
				focus: true,
				show: true,
			}).on('hidden.bs.modal', function(e) {
				$(this).modal('dispose').remove();
			})

			$modal.find('.filterBtn').on('click', () =>
			{ 
				$modal.modal("hide");
				$filterModal.modal('show')
			});

			// Perform filtering
			$modal.find('.sceneList .actListItem').each((i, elem) => {
				let playInfo = self.plays.find(x => x._id === $playItem.data('playId'));
				let actInfo = playInfo.acts.find(x => x._id === $(elem).data('actId')); 

				$(elem).data('act', actInfo);

				 // remove all excluded difficulties

				 if (isActFiltered(actInfo)) {
					$(elem).addClass('filtered');
				}
			});

			$modal.find('.sceneList .actListItem:not(.filtered)').each((x, elem) => {
				if (x % 2 === 0) {
					$(elem).addClass('even');
				}
			})


			$modal.find('.actCell').on('click', function(e) {
				const $cell = $(this);
				const $item = $cell.parents('.actListItem');
				const filteredActs = $.map($modal.find('.sceneList .actListItem.filtered'), a => $(a).data('actId'));
				const send = { actId: $item.data('actId'), play: $playItem.data('playId'), filteredActs: filteredActs };

				self.lobby.emit('create', send);
				$modal.modal('hide');
			})

			if ($modal.find('.actListItem.filtered').length === 0) {
				$modal.find('.filterNotification').hide();
			}
		});

		const isActFiltered = act => {
			const excludedDifficulties = $availableActs.data('filtered').exclude;
			const includedDifficulties = $availableActs.data('filtered').include;

			if (!act.difficulties) {
				if (includedDifficulties.length > 0) {
					return true;
				} else { return false; }
			}

			const actDifficulties = act.difficulties.map(x => x._id)
			let filtered = false;

			excludedDifficulties.some(diff => {
				if (actDifficulties.includes(diff)) {
					return filtered = true;
				} 
			});

			includedDifficulties.some(diff => {
				if (!actDifficulties.includes(diff)) {
					return filtered = true;
				} 
			});

			return filtered;
		}


		const isPlayFiltered = $play => {
			let acts = $play.data('play').acts || [];
			let nonFilteredActs = acts.filter(a => !isActFiltered(a));

			return nonFilteredActs.length === 0;
		}

		const recalculatePlaysAffectedByFilter = () => {

			$(".playItem").each((index, elem) => {
				let $elem = $(elem);

				if (isPlayFiltered($elem)) {
					$elem.parent().addClass('filtered');
				} else {
					$elem.parent().removeClass('filtered');
				}
			})

		}

        $filterModal.find('.difficulty-item').on('click', (event) => {
          let $filterItem = $(event.currentTarget);
          let $filterItemContainer = $filterItem.parent().parent();

		  const isIncludeFilter = !$filterItemContainer.hasClass('exclude-filter');
		  const isExcludeFilter = !isIncludeFilter;
 
          let twinItemContainer_class = '.' + ($filterItemContainer.hasClass('exclude-filter') ? 'include-filter' : 'exclude-filter');

          if ($filterItem.hasClass('disabled'))
            return false;

          // the "twin" is the identical difficulty item in the neighboring filtering list.
          let $twinItem = $(twinItemContainer_class).find('[data-id="'+$filterItem.attr('data-id')+'"]');

		  let cssClass = isExcludeFilter ? 'bg-gradient-danger' : 'bg-gradient-success';

          $filterItem.toggleClass('selected').toggleClass('bg-gradient-primary');
		  $filterItem.toggleClass(cssClass);
          $twinItem.toggleClass('disabled');

          let excludedIds = [];
          $('.exclude-filter li.selected').each((k, v) => excludedIds.push($(v).data('id')));

          let includedIds = [];
          $('.include-filter li.selected').each((k, v) => includedIds.push($(v).data('id')));

		  $availableActs.data('filtered').exclude = excludedIds;
		  $availableActs.data('filtered').include = includedIds;
		  recalculatePlaysAffectedByFilter();
        });

        
        // if they are a COPPA child, remove the adult difficulties
		let forcedExcluded = (requestImport.role.isChild ? data.difficulties.filter(d => d.adult).map(x => x._id) : []);
		$availableActs.data('filtered').exclude = [...$availableActs.data('filtered').exclude, ...forcedExcluded];
		recalculatePlaysAffectedByFilter();

        forcedExcluded.forEach(fE => {
          let $excludeFilterButton = $('.exclude-filter .difficulty-item[data-id="'+fE+'"]');
          let $includeFilterButton = $('.include-filter .difficulty-item[data-id="'+fE+'"]');
          
          $excludeFilterButton.click().addClass('selected').hide();
          $includeFilterButton.remove();
        });
        
        // Remove click events on these to mitigate trickery.
        $('.playItemContainer.filtered .actItem').off('click');

      } else if (data.eventName == "error") {
        self.displayError(data.message);
      } else if (data.eventName == "setting-change") {
		  if (data.payload.settingName == 'title') {
			if (data.external && !self.presentation._id) {
				let $target = $(`.presentationItem[data-presentation-id="${data.payload.presentation}"] .header .playTitle`)
				$target.text(data.payload.settingValue);

				return;
			}

			self.presentation.title = data.payload.settingValue;
          if (data.payload.settingValue.length > 0) {
            $("#pageTitle").text(data.payload.settingValue);
            $("#pageSubtitle").show();
            if (data.payload.assigner != user.id)
              $('.settingsBox input[data-settingname="title"]').val(data.payload.settingValue);
          }
          else {
            $("#pageTitle").text(self.presentation.play.title);
            $("#pageSubtitle").hide();
            $('.settingsBox input[data-settingname="title"]').val('');
          }
        } else if (data.payload.settingName == 'venues' && data.payload.assigner != user.id) {
          // remove all currently selected values
          $("#venues option").prop("selected", false);
          for (let x = 0; x < data.payload.settingValue.length; x++) {
            let venue = data.payload.settingValue[x];
            $("#venues").find('option[value="' + venue + '"]').prop("selected", true);
          }
        } else if (data.payload.settingName == 'currentAct') {
			if (data.external && !self.presentation._id) {
				let $target = $(`.presentationItem[data-presentation-id="${data.payload.presentation}"] .presentationBody .actTitle`)
				$target.text(data.payload.newAct.title_normalized);

				return;
			}
          // This change requires the entire view be redrawn, so let's do that!
          self.lobby.emit('show', { targetSelf: true, presentationId: self.presentation._id });
        } else {
          self.Settings[data.payload.settingName] = data.payload.settingValue;

          if (self.isPrivilegedUser && data.payload.assigner != user.id) {
            // is it a boolean?
            if (data.payload.settingValue === true || data.payload.settingValue === false) {
              let $option = $('input[data-settingname="' + data.payload.settingName + '"]');
              let addClass = $option.prop("checked") == true ? "off" : "on";
              $option.prop("checked", data.payload.settingValue);
              if (!data.payload.settingValue) {
                $option.parent().addClass("off")
                $option.parent().addClass("btn-danger");
                $option.parent().removeClass("btn-success");
              } else {
                $option.parent().removeClass("off")
                $option.parent().removeClass("btn-danger");
                $option.parent().addClass("btn-success")
              }
            }
          }

          if (data.payload.settingName == 'openCasting') {
            if (data.payload.settingValue === true)
              $('i.toggleIcon.fa').fadeIn();
            else if (!self.isPrivilegedUser) {
              $('i.toggleIcon.fa').fadeOut();
            }
          } else if (data.payload.settingName == 'showSceneCharactersOnly') {
			self.lobby.emit('show', { targetSelf: true, presentationId: self.presentation._id });
          } else if (data.payload.settingName == 'notes' && data.payload.assigner != user.id) {
            $("#notes").text(data.payload.settingValue);

            if (!self.isPrivilegedUser)
              $("#notes").addClass('unread');
            
            // Adjust the height. We'll have to guess here.
            let lineHeight = 18;
            let charactersPerLine = 20;
            let textAdjustment = Math.ceil($("#notes").text().length / charactersPerLine) * lineHeight;
            let lineBreaks = data.payload.settingValue.split("\n").length * lineHeight;
            $("#notes").css("height", textAdjustment+lineBreaks);
           
          }
        }
      }
      // Someone has joined the lobby
      else if (data.eventName == 'spectator-join') {
		if (!self.presentation._id && data.external) {
			let newString = `${data.payload.newCount} user${data.payload.newCount !== 1 ? 's' : ''}`;
			let $target = $(`.presentationItem[data-presentation-id="${data.payload.presentation}"] .spectatorCount .countLabel`)
			
			$target.text(newString);
			
			return;
		}

        $('li.castMember[data-user-id="' + data.payload._id + '"]').addClass('online');

        if (!self.spectatorExists(data.payload._id)) {
          self.spectators.push(data.payload);
		  data.payload.onlineClass = 'online';
		  data.payload.actCompleted = (data.payload.completed && data.payload.completed.acts ? data.payload.completed.acts.find(a => String(a.item) == String(self.presentation.currentAct)) !== undefined : false); 
		  let $spec_html = self.$items.castMember.render(data.payload);
          let $spec = $($spec_html);
          $spec.hide();

          if (data.payload._id == user.id)
            $spec.addClass('self-user');

          if (self.$castContainer !== null) {
            if ($("#castSourceList").find('li.castMember[data-user-id="' + data.payload._id + '"]').length == 0)  {
              self.$castContainer.append($spec);
              $spec.fadeIn(550);
            }
          } else {
            // The container might not exist yet, so let's try shortly.
            setTimeout(() => {
              if ($("#castSourceList").find('li.castMember[data-user-id="' + data.payload._id + '"]').length == 0)  {
                self.$castContainer.prepend($spec);
              }
              $spec.fadeIn(550); }, 300);
          }
        }
      }
      // Someone has quit the lobby
      else if (data.eventName == 'spectator-quit') {

		if (!self.presentation._id && data.external) {
			let newString = `${data.payload.newCount} user${data.payload.newCount !== 1 ? 's' : ''}`;
			let $target = $(`.presentationItem[data-presentation-id="${data.payload.presentation}"] .spectatorCount .countLabel`)
			
			$target.text(newString);
			
			return;
		}

        $('li.castMember[data-user-id="' + data.payload._id + '"]').removeClass('online');

        if (self.spectatorExists(data.payload._id)) {
          self.spectators = self.spectators.filter(s => s._id != data.payload._id);
          let $role_spec = $("#roleContainer").find('li.castMember[data-user-id="'+data.payload._id+'"]');
          // we only want to remove them from available cast if they do not already have a role assigned or if they are not apart of the organization that created the presentation
          let hasRole = ($role_spec.length > 0);
          let isOrganizationMember = $role_spec.hasClass('organizationMember');

          let $spec = $("#castSourceList").find('li.castMember[data-user-id="' + data.payload._id + '"]');

          if (!hasRole && !isOrganizationMember)
            $spec.fadeOut(550,  () =>$spec.remove() );
            
          self.$castContainer.append($spec);
          $spec.fadeIn(550);

        }
      }
      // the lobby is deleted
      else if (data.eventName == 'deleted') {
        if (self.presentation._id === data.payload.presentation) {
			window.location = "/lobby";
		} else {
			let $container = $(`.presentationItem[data-presentation-id="${data.payload.presentation}"]`).parents('.lobby-play-box')
			$container.fadeOut(1200, () => {
				$container.remove()

				if ($('.lobby-play-box').length === 0) {
					$('#emptyPresentationsMsg').fadeIn()
				}
			})
		}
      }
      // a role has been assigned to someone 
      else if (data.eventName == 'role-assign') {
        // Do not need to animate if current user did the assignment
        if (data.payload.assigner != user.id) {
          let $destination = $("ul#roleContainer").find('ul[data-role-id="' + data.payload.characterId + '"]');
          let $target = self.$castContainer.find('li.castMember[data-user-id="' + data.payload.userId + '"]');

          if ($destination.find('li.castMember[data-user-id="' + data.payload.userId + '"]').length == 0)
            self.moveAnimate($target, $destination, true);
        }
      
        if (data.payload.userId == user.id) 
          self.updateJoinIcons();

       
      } 
      else if (data.eventName == 'role-unassign') {
        // Do not need to animate if current user did the assignment
        if (data.payload.assigner != user.id) {
          let $destination = $("ul#roleContainer").find('ul[data-role-id="' + data.payload.characterId + '"]');
          let $target = $destination.find('li.castMember[data-user-id="' + data.payload.userId + '"]');
          $target.fadeOut(550, () => { $target.remove(); self.updateJoinIcons(); });

        }

        // If they do not have any roles and are not online, we remove them from the available cast list
        // but wait a few before checking this, in case they are just being swapped (to prevent premature UI removal)
        setTimeout(() => {
		  let $availableCastUser = $("#castSourceList").find('li.castMember[data-user-id="' + data.payload.userId + '"]');
		  let hasRole = ($("#roleContainer").find('li.castMember[data-user-id="' + data.payload.userId + '"]').length > 0);
		  let isOrgMember = $availableCastUser.hasClass('organizationMember');

          if (!hasRole && !self.spectatorExists(data.payload.userId) && !isOrgMember) {
            self.cast = self.cast.filter(c => c._id != data.payload._id);
            $availableCastUser.fadeOut(550, () => $availableCastUser.remove());
          }
        }, 750);
      }
        // This is for when it's a temporary user trying to access a lobby that his account wasn't created for.
      else if (data.eventName == 'trespass') {
        window.location = '/connect/local';
      }
      else if (data.eventName == 'maxCapacity') {
        let modal = self.$items.licenseModal.render({message:"The license for this subscription has reached its limit for concurrent users."});
        $(modal).modal({keyboard: false, backdrop: 'static'});
        return 0;
      } else if(data.eventName == 'unentitledCreate') {
			let modal = self.$items.licenseModal.render({message:'This scene is only available to those with a paid subscription. <div class="text-center mt-3"><a href="/subscribe" class="btn btn-standoutOne">Upgrade Now</a></div>', okButton:true});
			$(modal).modal({keyboard: false, backdrop: 'static'});
			return 0;
	  }
      else if (data.eventName == 'maxPresentations') {
        let modal = self.$items.licenseModal.render({message:"The license for this subscription has reached its limit ("+data.payload.max+") for concurrent presentations. Please delete ones you are no longer using or consider upgrading the subscription package.", okButton: true});
        $(modal).modal();
        return 0;
      } else if (data.eventName == 'notAvailableBilling') {
        let modal = self.$items.licenseModal.render({message:"This lobby is not available. Please contact the plan's billing administrator."});
        $(modal).modal();
        return 0;
      }
      // Show play join interface with character selection
      else if (data.presentation) {

        if (data.availableVenues) {
          data.presentation.availableVenues = data.availableVenues;
        }
        // Set the current presentation
        self.presentation = data.presentation;
        self.Settings = data.presentation.settings;
        self.isPrivilegedUser = (requestImport.role.isAdmin || self.presentation.owner == user.id || 
          (self.presentation.organization && requestImport.user.organization && requestImport.user.organizationRole  && self.presentation.organization._id == requestImport.user.organization._id && requestImport.user.organizationRole.canDirectPlays));
        


        // Add the selectedCharacters for this user
        self.selectedChars = data.presentation.players.filter(i => i && i.user && i.user._id == window.user.id).map(x => x._id);

		data.audioPreviews = [];
		data.linkedTutorials = [];

		const currentActFull = data.presentation.play.acts.find((act) => act._id == data.presentation.currentAct._id);

		currentActFull.media.forEach((media) => {
			const name = media.name.toLowerCase();

			media.hasLyrics = media.synced.find(
				s => s && s.type.name == "Lyric-Extended" && s.lyrics.length > 0
			) !== undefined;

			if (name.includes('audiodrama') || name.includes('songwithsinger')
			|| name.includes('songwsoftsinger') || name.includes('lobby')
			|| media.hasLyrics) {

				if (!media.hasLyrics && (name.includes('songwithsinger') || name.includes('songwsoftsinger'))) {
					// find the 'Song' version of this file.
					let partnerSong = currentActFull.media.find(partner =>
						!partner.name.toLowerCase().includes('songwithsinger')
							&& !partner.name.toLowerCase().includes('songwsoftsinger')
							&& partner.name.toLowerCase().includes('song')
					);

					if (partnerSong) {
						let partnerHasLyrics = partnerSong.synced.find(
							s => s.type.name == "Lyric-Extended" && s.lyrics.length > 0
						) !== undefined;

						if (partnerHasLyrics) {
							media.hasLyrics = true;
							media.synced.push(partnerSong.synced.find(
								s => s.type.name == "Lyric-Extended" && s.lyrics.length > 0
							));
						}
					}
				}

				data.audioPreviews.push(media);
			} else if (media.type.name == 'Tutorial') {
				data.linkedTutorials.push(media);
			}
		});

		data.currentUser = requestImport.user;

		let sceneCharacters = data.sceneCharacters;
		sceneCharacters.sort((a,b) => a.name.localeCompare(b.name));
		
		data.presentation.currentAct.characterList = {};
		data.presentation.currentAct.characterList_flat = [];
		data.presentation.currentAct.characterList.speaking = data.sceneCharacters.filter(scr => scr.isSpeaking)
		data.presentation.currentAct.characterList.nonspeaking = data.sceneCharacters.filter(scr => !scr.isSpeaking)
		data.sceneCharacters.forEach(c => {
			if (c.deleted || data.presentation.currentAct.characterList_flat.includes(c._id))
				return;

			data.presentation.currentAct.characterList_flat.push(c._id);
		})

		let html = self.$templates.lobbyEdit.render(data);
        self.$lobbyContainer.html(html);
		self.$castContainer = $("#castSourceList");

		scrollToSelector('#pageTitle');

		// Update the shareable link
		let $shareableURL = $('.shareableURL');
		$shareableURL.text(`${location.host}/${data.presentation.commonName_case}`);
		
		let originalLinkText = $shareableURL.text();
		let $newLink = $("<a>");
		let $QRCanvas =  $("#canvasQR");
		$newLink.text(originalLinkText);
		$newLink.attr('href', "/" + data.presentation.commonName_case);
		
		let canvasURL = window.location.protocol + "//" + $newLink.text();
		
		$shareableURL.html($newLink);

		if (data.presentation.settings.showCodeWord && $QRCanvas.data('url') !== canvasURL) {
			var qrCode = new QR.generator({element: $QRCanvas[0], value: canvasURL, level: 'Q'});
			$QRCanvas.data('url', canvasURL);
		}

		// Update the scene list to indicate completions
		if (data.currentUser.completed && data.currentUser.completed.acts) {
			$("#scenes").find("option").each((k,v) => {
				let $this = $(v);
				if (data.currentUser.completed.acts.find(a => a.item == $this.attr('value')) !== undefined)
					$this.text('✔ '+$this.text());
				else {
					$this.html("✘ "+$this.text());
				}
			})
		}

		// Bind media data to audio preview dropdown
		data.audioPreviews.forEach(aP => {
			let $target = $(`select.previewAudio option[data-media-id="${aP._id}"]`);

			$target.data('media', aP);

			if (aP.hasLyrics) {
				$target.data('lyrics', self.assembleLyricCollection(aP));
			}
		});

        // Remove unread indicator
        $('label[for="notes"]').click(() => $("#notes").removeClass('unread'));

        // stuff concerning the settings box
        if (self.isPrivilegedUser) {
          let sendUpdate = (presentationId, setting, value) => self.lobby.emit('set', { presentationId: presentationId, settingName: setting, settingValue: value } );
      
          // fancy up the toggles in the settings menu
          $('input[data-toggle="toggle"]').bootstrapToggle({ size: 'small', offstyle: 'dark', onstyle: 'success', height: 20, width: 44 }).on('change', function (event) {
            let target = event.currentTarget;
            sendUpdate(self.presentation._id, target.dataset.settingname, target.checked);
          });

		  $('.settingObject').on('click', function(event) {
			$(this).find('.toggle input').bootstrapToggle('toggle')
			event.stopPropagation();
		  });

          $('.settingsBox select#venues').change((event) => {
            // get list of selected venue IDs
            let field = event.currentTarget;
            let $field = $(field);
            let selectedVenues = [];
            
            $field.find('option:selected').each((k, v) => selectedVenues.push($(v).attr('value')));

            sendUpdate(self.presentation._id, $field.attr('data-settingName'), selectedVenues);
              
          });

          $('.settingsBox select#scenes').change((event) => {
            // get list of selected venue IDs
            let field = event.currentTarget;
            let $field = $(field);
            let selectedScene = $field.find("option:selected").attr('value');

            sendUpdate(self.presentation._id, $field.attr('data-settingName'), selectedScene);

          });

		  let titleUpdateTimer;
          $('.settingsBox input[type="text"], .settingsBox textarea').keyup(function (event) {
            let target = event.currentTarget;
            let $target = $(target);
			if (self.presentation.title !== target.value) {
				clearTimeout(titleUpdateTimer);
            	titleUpdateTimer = setTimeout(() => sendUpdate($target.parents('div.settingsBox').attr('data-presentation'), $target.attr('data-settingName'), target.value), 1500);
			}
          });

          $(".begin-presentation").click(() => {
            self.lobby.emit('start', { presentationId: self.presentation._id});

            // if the user only has one venue available, select it for the user.
            let $venueSelect = $('select[data-settingname="venues"]');
            let $options = $venueSelect.find('option');
            let $optionsSelected = $venueSelect.find('option:selected');

            // If they are already selected, we don't want to re-click them. Waste of database resources.
            if ($options.length === 1 && $optionsSelected.length === 0) {
              $options.prop('selected', true);
              $venueSelect.change(); // fire the event, so DB gets updated.
            } else if ($optionsSelected.length > 0) {
              // We want to make sure the venues themselves are pointed to this presentation
              // we do this by sending an update setting signal targeting venues.
              $venueSelect.change();
            }
          });
          $("#resyncLobby").click(() => self.lobby.emit('show', { presentationId: self.presentation._id, targetSelf: false }));
          $("#deletePresentation").click(() => $("#deleteConfirmation").modal({ keyboard: false, backdrop: 'static', show: true }));
          $(".delete-confirm").click(() => self.lobby.emit('delete', { presentationId: self.presentation._id }));
       
         // populate the selected venues
          if (data.presentation.venues) {
            for (let x = 0; x < data.presentation.venues.length; x++) {
              let venue = data.presentation.venues[x];
              $("#venues").find('option[value="' + venue + '"]').attr("selected", "selected");
            }
          }

          // set up audio previews
          const $previewAudio = $('.preview-audio');
          const $paSelect = $previewAudio.find('select');
		  const $paOpen = $previewAudio.find('.open-media-preview');
          let $paAudio;

          let $oggPlayer = null;
		  let $oggPlayerControl = null;
		  

		  let workingLine = -1;
		  let latestPosition = -1;
		  let buildLine = (trackingLine) => {

			let $line = $("<line></line>");
			if (!trackingLine || !trackingLine.timing) {
				return $line;
			}

	
			trackingLine.timing.forEach(word => {
				let textWord = word.eol ? word.words : word.words + ' ';

				if (textWord.trim().length == 0) {
					textWord = "&nbsp;";
				}
				let $word = $(`<word>${textWord}</word>`);

				$line.append($word);
			});

				return $line;
		  };

		  $paSelect.on('change', function(event) {
			let $this = $(this);

			if ($this.val()) {
				$paOpen.removeClass('disabled').prop('disabled', false);
				$paOpen.attr('title', 'Open Media Item');
			} else {
				$paOpen.addClass('disabled').prop('disabled', true);
				$paOpen.attr('title', "Please select a valid media item.");
			}
		  }).trigger('change');

		  $paOpen.on('click',function(e) {
			  const $selected = $paSelect.find('option:selected');
			  const data = $selected.data('media') || {};
			  const selectedUrl = $selected.val();
			  const $modal = $(self.$items.mediaPreviewModal.render({data, selectedUrl}));

			  if (!selectedUrl) {
				  return;
			  }

			  $paAudio = $modal.find('.mediaPlayer')
			  
			  console.log($modal, $paAudio);

			  $modal.modal({backdrop: 'static', keyboard: false, show:false});
			  setUpPreviewMedia($modal);

			  $modal.modal('show');


			  $modal.on("hidden.bs.modal", function(e) {
				  $modal.remove();
			  });
			  
		  });

          let setUpPreviewMedia = function ($modal) {
            const url = $paSelect.val();
			const $lyrics = $modal.find('lyrics');
			const lyric_data = $paSelect.find('option:selected').data('lyrics');

			if (lyric_data) {
				let $player = $oggPlayer || $paAudio;
				$lyrics.show();
				$player.data('lyrics', lyric_data);

				$player.on('timeupdate', function() {
					let trackingLine = $player.data('lyrics').find(t => t.min <= this.currentTime && t.max >= this.currentTime);

					if (!trackingLine) {
						return;
					}

					let lineNumber = $player.data('lyrics').indexOf(trackingLine);

					if (workingLine != lineNumber) {
						latestPosition = -1;
						workingLine = lineNumber;

						let $line = buildLine(trackingLine);
						$line.data('currentLine', true);
						$lyrics.html($line);
					}

					// Figure out the closest word by looking at the deltas
					let nearestDelta;
					let selectedPosition;
					trackingLine.timing.forEach((word,pos) => {
						let delta = Math.abs(this.currentTime - word.time);

						if (!nearestDelta || delta < nearestDelta) {
							nearestDelta = delta;
							selectedPosition = pos;
						}
					});
					
					// only do this work if we've changed positions
					if (selectedPosition !== latestPosition) {
						// $('lyrics line word.highlighted').removeClass("highlighted");

						for (let x = 0; x<=selectedPosition; x++) {
							let $highlightedWord = $($lyrics.find('line word')[x]);

							if ($('lyrics line').data('currentLine') === true)
								$highlightedWord.addClass('highlighted');

							// if the last word is a zero length string, then we treat that as a signal to go to the next line
							// this shows the next line before it starts to give people a chance to visually scan the lyrics as its approaching.
							if ($highlightedWord.text().trim() == '' && selectedPosition+1 == trackingLine.timing.length) {
								let nextLine =  $player.data('lyrics')[lineNumber+1];
								$('lyrics line word.highlighted').removeClass("highlighted");
								if (nextLine) {
									selectedPosition = latestPosition = -1;
									let $newLine = buildLine(nextLine);
									$newLine.data('currentLine', false)
									$lyrics.find('line').replaceWith($newLine);
								}
							}
						}
					}
				})
			} else {
				$lyrics.hide();
			}


            if (url.endsWith('.ogg') && !$paAudio[0].canPlayType('audio/ogg')) {
              if ($oggPlayer == null) {
                $oggPlayer = $(new OGVPlayer({ controls: true }));

                $oggPlayerControl = $(document.createElement('i'));
                $oggPlayerControl.attr('class', 'fa fa-play');

                $oggPlayer.on('pause ended', function () {
                  $oggPlayerControl.removeClass('fa-pause');
                  $oggPlayerControl.addClass('fa-play');
                });
                $oggPlayer.on('play', function () {
                  $oggPlayerControl.addClass('fa-pause');
                  $oggPlayerControl.removeClass('fa-play');
                });

                $oggPlayerControl.on('click', function () {
                  if ($oggPlayer[0].currentTime > 0 && !$oggPlayer[0].paused && !$oggPlayer[0].ended) {
                    $oggPlayer[0].pause();
                  } else {
                    $oggPlayer[0].play();
                  }
                });

                $previewAudio.append($oggPlayer);
                $previewAudio.append($oggPlayerControl);
              }
              $paAudio.hide();
              $oggPlayer.show();
              $oggPlayerControl.show();
              $oggPlayer.attr('src', url);
              $oggPlayer[0].load();
            } else {
              $oggPlayer && $oggPlayer.hide() && $oggPlayerControl.hide();
              $paAudio.show();
              $paAudio.attr('src', url);
              $paAudio[0].load();
            }
          }

        }
		
		$('.btn-join-presentation').click(() => {
			const webVenue = self.presentation.availableVenues.find(venue => venue.unity == 'web-' + self.presentation._id);
			const webVenueSelected = self.presentation.venues.find(venueId => webVenue && venueId == webVenue._id);
	
			let url = webVenueSelected ? '/player/' : '/present/';
			url += self.presentation._id;
			url += (self.isPrivilegedUser && data.directorUserId && String(data.directorUserId) == user.id) ? '/direct': '';

			window.location.href = url;
		});
		
        if (data.presentation.organization)
          $("#orgTitle").text(data.presentation.organization.name);

        $('#pageTitle').text(data.presentation.title || data.presentation.play.title_normalized);
        $("#pageSubtitle").text(data.presentation.play.title_normalized);

        // we need to figure out position of the current act in the act list
        let sceneFound = false;
        let sceneNumber;
        for (sceneNumber = 0; sceneNumber < data.presentation.play.acts.length && !sceneFound; sceneNumber++) {
          if (data.presentation.play.acts[sceneNumber]._id == data.presentation.currentAct._id)
            sceneFound = true;
        }

        $("#pageTertiaryTitle").text("Scene "+sceneNumber+" - "+data.presentation.currentAct.title_normalized);

        if (!data.presentation.title) {
          $("#pageSubtitle").hide();
        }

        $('title').text("ActorsBible - Lobby - " + data.presentation.currentAct.title_normalized);
        window.history.pushState({presentationId: data.presentation._id}, "ActorsBible - Lobby - " + data.presentation.currentAct.title, data.presentation.commonName_case);

        if (!self.Settings.openCasting && !self.isPrivilegedUser) {
          $('i.toggleIcon').hide();
        }
        if (self.countdown)
          $('.lobby-countdown').show().html(self.countdown);
      

        // Update our list of spectators
        if (data.spectators) {          
          let newSpectators = data.spectators;
          // Add yourself to the list if you're not already in it
          if (!self.spectatorExists(user.id)) {
            newSpectators.push({ _id: user.id, displayName: requestImport.user.displayName});
          }

          for (let x = 0; x < newSpectators.length; x++) {
            let spec = newSpectators[x];
			spec.onlineClass = 'online';
			spec.actCompleted = (spec.completed && spec.completed.acts ? spec.completed.acts.find(a => String(a.item) == String(self.presentation.currentAct._id)) !== undefined : false);
            let $spec_html = self.$items.castMember.render(spec);
            let $spec = $($spec_html);
            self.spectators.push(spec);

            $spec.hide();
            if (spec._id == user.id)
              $spec.addClass('self-user');

            if ($('li.castMember[data-user-id="' + spec._id + '"]').length == 0) {
              self.$castContainer.append($spec);
            }
            $spec.fadeIn(550);
          }

		}
		
		if (data.presentation.play.characters) {
			data.presentation.play.characters.filter(c => c.description).forEach(c => {
				$('.character-select-item[data-character-id="'+c.id+'"] .characterInformation').data('description', c.description).data('name', c.name);
			});
		}

        // our cast list (including non spectators)
        if (data.presentation.players) {
          for (let x = 0; x < data.presentation.players.length; x++) {
            if (data.presentation.players[x].user) {
              let actor = data.presentation.players[x].user
			  actor.onlineClass = (data.spectators.find(s => s._id == actor._id) ? 'online' : '');
			  actor.actCompleted = (actor.completed && actor.completed.acts ? actor.completed.acts.find(a => String(a.item) == String(data.presentation.currentAct._id)) !== undefined : false);
              let actor_html = self.$items.castMember.render(actor);
              let $actor = $(actor_html);
              let $roleContainer = $('ul#roleContainer ul[data-role-id="' + data.presentation.players[x].character._id + '"]');

              if (!self.castExists(data.presentation.players[x].user._id)) {
                self.cast.push(actor);
              }

              $actor.hide();
              if (actor._id == user.id)
                $actor.addClass('self-user');
              // make sure they aren't already in the lists
              if (self.$castContainer.find('li.castMember[data-user-id="' + actor._id + '"]').length == 0)
                self.$castContainer.append($actor);
              if ($roleContainer.find('li.castMember[data-user-id="' + actor._id + '"]').length == 0)
                 $roleContainer.append($actor.clone());

              $actor.fadeIn(550);
            }
          }

          self.updateJoinIcons();
        }

        if (data.organizationMembers && data.organizationMembers.length > 1) {
          data.organizationMembers.forEach(member => {
            let actor_html = self.$items.castMember.render(member);
            let $actor = $(actor_html);

            if (!self.castExists(member._id)) {
              self.cast.push(member);
            }

            $actor.hide();

            if (member._id == user.id)
              $actor.addClass('self-user');
            // make sure they aren't already in the lists
            if (self.$castContainer.find('li.castMember[data-user-id="' + member._id + '"]').length == 0)
              self.$castContainer.append($actor);

              // Mark them as an org member
            $('li.castMember[data-user-id="' + member._id + '"]').addClass('organizationMember');
            $actor.fadeIn(550);
          });
        }

        // if for some reason we're STILL not in the available cast list, add us.
        if ($('li.castMember.self-user').length == 0) {
          let me = self.$items.castMember.render(requestImport.user);
          let $me = $(me);

          $me.addClass('self-user');
          self.$castContainer.append($me);
        }
        self.prepareSortable();
        // If they have selected a character, make the Ready button available
        if (self.selectedChars.length)
          $('#presentation-ready')
          .attr('disabled', false)
          .click(function () {
            let $this = $(this),
              send = {presentationId: $this.attr('data-presentation-id'), players: self.selectedChars};
            if (!$this.hasClass('status-ready')) {
              $this.addClass("status-ready");
              $this.find('.fa').addClass('fa-check-square-o').removeClass('fa-square-o');
              self.isReady = true;
              self.lobby.emit('ready', send);
            } else {
              $this.removeClass("status-ready");
              $this.find('.fa').removeClass('fa-check-square-o').addClass('fa-square-o');
              self.isReady = false;
              self.lobby.emit('unready', send);
            }
		  });
		  
		$(".characterInformation").click(function() {
			let description = $(this).data('description').trim().split("\n").join("<br />");
			if (description) {
				let $modal = $(self.$items.bioModal.render({ name: $(this).data('name'), description: description }))
				$modal.on("hidden.bs.modal", function () {
					$(this).remove();
				});
				$modal.modal({keyboard: true, backdrop:'static', show: true });
			}
		});

        // Allow users to select characters
        $('.character-select-item').click(function (evt) {
			if ($(evt.target).hasClass('characterInformation'))
				return;
			
          var $this = $(this),
            send = {userId: user.id, characterId: $this.attr('data-character-id'), presentationId: $this.attr('data-presentation-id')};
          // Only if open casting is on (or we're privileged)
          if (self.Settings.openCasting == true || self.isPrivilegedUser) {
            let $destination = $("ul#roleContainer").find('ul[data-role-id="' + $this.attr('data-character-id') + '"]');
            let $target = self.$castContainer.find('li.castMember[data-user-id="' + user.id + '"]');
            // if we already have the role, don't assign again.
            if ($destination.find('li.castMember[data-user-id="' + user.id + '"]').length == 0) {
              
              self.moveAnimate($target, $destination, true);
              self.lobby.emit('assign', send);
            } else {
              //  but we'll unassign it, instead
              let $assignment = $destination.find('li.castMember[data-user-id="' + user.id + '"]');
              $assignment.fadeOut(550, null, () => { $assignment.remove(); self.updateJoinIcons(); } );
              self.lobby.emit('unassign', send);
            }
          }
		});

		// Trigger tutorial completion
		help.guided.completeStep('open-presentation');
      }

      // If the user just created something, they should select it
      else if (data.created) {
        console.log('data.created: ', data.created);
        self.lobby.emit('show', { presentationId: data.created._id, targetSelf: true });
      }

      // If the user is getting a countdown, then they should see the countdown clock with the value in it
      else if (data.countdown) {
        console.log('data.countdown: ', data.countdown);
      }
    });

	// Load the lobby if direct link is given.
  if (self.presentation._id) {
      self.lobby.emit('show', { targetSelf:true, presentationId: self.presentation._id });
    } else {
      // Lists the current presentations for the user
      self.lobby.emit('list', { targetCollection: targetCollection || '' });
    }

  // Closure
  return {};
};

$(document).ready(function() {
  _Lobby(window.requestImport);
});
